export default __webpack_public_path__ + "static/media/LogoIES.caf90521.png";